import { MoCommand } from './command';
import { MoveToObjCmd } from './movetoobj';
import { playSkillSounds } from '../../helpers/soundmanager';
import { playSkillCastEffect } from '../../effects/effectmanager';

export class SkillActionToObjCmd extends MoCommand {
  pawn: any;
  target: any;
  skillData: any;

  constructor(object: any, targetObjRef: any, skillData: any) {
    super(object);
    this.pawn = this.object.pawn;
    this.target = targetObjRef;
    this.skillData = skillData;
  }

  enter() {
    playSkillSounds(this.skillData, SKILL.CASTING_SOUND1);
    playSkillCastEffect(this.pawn, this.skillData);
    let motionIdx = this.skillData[SKILL.CASTING_MOTION];
    let timeScale = this.skillData[SKILL.CASTING_SPEED] / 100;
    this.pawn.playMotion(motionIdx, timeScale, 1, function(anim) {
      anim.once('finish', this._skillCastDone.bind(this));
    }.bind(this));
  }

  _skillCastDone() {
    playSkillSounds(this.skillData, SKILL.REPEAT_SOUND1);
    let motionIdx = this.skillData[SKILL.REPEAT_MOTION];
    let timeScale = this.skillData[SKILL.CASTING_SPEED] / 100;
    let repeatCount = this.skillData[SKILL.REPEAT_COUNT];
    if (repeatCount < 1) {
      repeatCount = 1;
    }
    this.pawn.playMotion(motionIdx, timeScale, repeatCount, function(anim) {
      anim.once('finish', this._skillRepeatDone.bind(this));
    }.bind(this));
  }

  _skillRepeatDone() {
    playSkillSounds(
      this.skillData,
      SKILL.ACTION_SOUND1,
      SKILL.ACTION_SOUND2,
      SKILL.SHOT_SOUND,
      SKILL.HIT_SOUND,
      SKILL.HIT_SOUND2,
      SKILL.HIT_SOUND3,
      SKILL.AREA_SOUND,
    );
    const motionIdx = this.skillData[SKILL.MOTION];
    const timeScale = this.skillData[SKILL.SPEED] / 100;
    this.pawn.playMotion(motionIdx, timeScale, 1, function(anim) {
      anim.once('finish', this._skillDone.bind(this));
    }.bind(this));
  }

  _skillDone() {
    this.isComplete = true;
    this.emit('finish');
  }

  leave() {
  }

  update(delta: number) {
    return 0;
  }
}


export class SkillToObjCmd extends MoCommand {
  target: any;
  skillData: any;
  activeCmd: any;

  constructor(object: any, targetObjRef: any, skillData: any) {
    super(object);
    this.target = targetObjRef;
    this.skillData = skillData;
    this.activeCmd = null;
  }

  enter() {
    this._goOnce();
  }

  leave() {
    if (this.activeCmd) {
      this.activeCmd._leave();
      this.activeCmd = null;
    }
  }

  _goOnce() {
    // Interupt here, as you cannot interupt in the middle of attack animation.
    if (this.wantInterrupt) {
      this.isComplete = true;
      return;
    }

    const rawRange = Number(this.skillData[SKILL.RANGE]);
    const skillDist = Number.isFinite(rawRange) && rawRange > 0
      ? rawRange / 100
      : this.object.stats.getAttackDistance();

    this.activeCmd = new MoveToObjCmd(this.object, this.target, skillDist);
    this.activeCmd.on('finish', function() {
      if (!this.activeCmd) {
        return;
      }
      this.activeCmd._leave();
      this.activeCmd = new SkillActionToObjCmd(this.object, this.target, this.skillData);
      this.activeCmd.on('finish', function() {
        if (!this.activeCmd) {
          return;
        }
        this.activeCmd._leave();
        this.activeCmd = null;

        this.isComplete = true;
        this.emit('finish');
      }.bind(this));
      this.activeCmd._enter();
    }.bind(this));
    this.activeCmd._enter();
  }

  update(delta: number) {
    if (this.wantInterrupt && !(this.activeCmd instanceof SkillActionToObjCmd)) {
      this.isComplete = true;
      return delta;
    }

    // If object went offscreen or died, stop attacking!
    if (!this.target.object || this.target.object.isDead) {
      this.isComplete = true;
      return delta;
    }

    if (!this.activeCmd) {
      // This is really an error condition, we eat the delta to make sure
      //   we don't loop forever in the caller loop.
      return 0;
    }

    return this.activeCmd.update(delta);
  }
}
